import React,{useCallback, useEffect, useState} from "react";
import {
  Flex,
  Spacer,
  Box,
  Img,
  Link,
  useColorModeValue,
  useMediaQuery,
  Text,
  InputGroup,
  Input,
  InputRightAddon,
  useDisclosure,
  InputRightElement,
  Button,
} from "@chakra-ui/react";
import { NavLink, useLocation } from "react-router-dom";
import SocialMedia from "./SocialMedia";
// import DappsDropdown from "./DappsDropdown";
import Logo from "../../assets/logo.png";
import LogoLight from "../../assets/logo2.svg";
import { IContext, TextContext } from "../../hooks/context";
import { BUSD, topAddresses } from "../../constants/addresses";
import { useActiveWeb3React } from "../../hooks/useActiveWeb3React";
import NetworkModal from "./modals/networkModal";
import useTransactionHistory from "../../hooks/useGetTransaction";
import { getERC20Token, isAddress } from "../../utils/utilsFunction";
import { ethers } from "ethers";

export const Nav = ({ to, label, active,img }: { to: string; label: string, active?:boolean,img?:any }) => {
  return (

  <NavLink
    to={to}
    // activeStyle={{
    //   color: "#319EF6",
    // }}
    color={active ? "#319EF6" : "#FFFFFF"}
    style={active ? {color:"#319EF6"}: {color:""}}
    
  >
    <Flex >
      {img} <Text ml="8px" fontSize="16px">{label}</Text>
    </Flex>
    
  </NavLink>
)};

const Index = () => {
  const [isMobileDevice] = useMediaQuery("(max-width: 750px)");
  const mobileNavColor = useColorModeValue("#FFFFFF", "#15202B");
  const mobileNavBorderColor = useColorModeValue("#DEE5ED", "#324D68");
  const {showText,setShowText,setAddress,setBalance,address,setIncoming,setOutgoing,loading,setNodes,setLinks,setPars,setMaxIndex,setChild,setChildrens,setID,setLoading,setList} = React.useContext(TextContext) as IContext
  const {account,library } = useActiveWeb3React()
  const LogoImg = useColorModeValue(Logo,LogoLight);
  // const [inputBox,setAddress] = useState("")
  const [displayNetwork,setDisplayNetwork] = useState(false)
  const [getValue,setGetValue] = useState(false)
  useTransactionHistory(getValue,address)
const { isOpen, onToggle } = useDisclosure()
  const searchForAddress = () => {
    // get random item from an array
    const randomItem = topAddresses[Math.floor(Math.random()*topAddresses.length)];
    setAddress(randomItem)
    setGetValue(!getValue)
    
  }
  const getBalance =async () =>{
    const tokenContract =await getERC20Token(BUSD[97],library)
      const balance =await tokenContract.balanceOf(address)
      setBalance(ethers.utils.formatUnits(balance.toString(),18))
    }
    useEffect(()=>{
      if(address){
         getBalance()
      }
    
    },[getValue])
  const connectWallet = useCallback(()=>{
    if(account){
      setAddress(account)
      setAddress(account)
      setGetValue(!getValue)
      
    }else {
      setDisplayNetwork(true)
    }
  },[account])

  
  const reset = () =>{
    
      setBalance("0")
      setAddress("")
      setAddress("")
      onToggle()
      setShowText(false)
      setIncoming([])
      setOutgoing([])
      setNodes([])
      setLinks([])
      setPars([])
      setMaxIndex(0)
      setChildrens([])
      setChild("")
      setID([])
      setLoading(false)
      setBalance("")
      setList([])
    
  }
  
  const feelingLucky = () => {
    // get random item from an array
      // get random item from an array
      reset()
      const randomItem = topAddresses[Math.floor(Math.random()*topAddresses.length)];
      // setAddress(randomItem)
      
      if(isAddress(randomItem)){
        setAddress(randomItem)
        setGetValue(!getValue)
        setChild("")
      //  onToggle()
       setShowText(true)
       }
      
  
  }
  return (
    <>
       
        <Flex w={["100%","100%","97%"]} mx="auto" py={2} boxShadow="sm" justifyContent="space-between" border="0">
          {isMobileDevice ? (
            <>
              <Flex w="100%" justifyContent="space-between" h="10" mx="20px">
                <Box mr={2} mt="10px" >
                  <NavLink to="/">
                    {" "}
                    {/* <Img src={Logo} /> */}
                    <Img src={Logo} width="150px" mt="-60px" ml="-15px"  />
                  </NavLink>
                </Box>
               
                
              </Flex>
             {showText &&   <Box
              padding="10px 0"
                zIndex="200"
                position="fixed"
                left={0}
                bottom={0}
                alignItems="center"
                borderTop="1px"
                borderColor={mobileNavBorderColor}
                w="100%"
                mx="auto"
                bgColor={mobileNavColor}
                mr={4}
              >
               <Box  mx="auto" w="90%">
                <InputGroup size='sm' width="100%" mt="10px" mx="auto">
            <Input placeholder="from" color="black" background="white"  height="40px" value={address} onChange={(e) => setAddress(e.target.value)} 
            borderRadius="6px"
            />
             <InputRightElement width='120px'>
        <Button bg="rgba(255, 83, 0, 1)" borderRadius="24px" color="white" height="40px" width="240px" mt="8px" size='sm' isLoading={loading} onClick={()=>{
              
              setGetValue(!getValue)
              }} 
              >
          Track
        </Button>
      </InputRightElement>
        </InputGroup>
        {/* <SocialMedia searchForAddress={searchForAddress} connectWallet={connectWallet} feelingLucky={feelingLucky} reset={reset} address={address} /> */}
        </Box>
              </Box>}
            </>
          ) : (
            <>
                <Box  mt={showText ? "10px" :0}>
                  <NavLink to="/">
                    {" "}
                    <Img src={Logo} mt="-50px" width="140px"/>{" "}
                  </NavLink>
                </Box>
                {account ? 
  <Box  mx="auto" width="600px">
               <SocialMedia searchForAddress={searchForAddress} connectWallet={connectWallet} feelingLucky={feelingLucky} reset={reset} address={address} />
        
        </Box> : <Button bgColor="#41134a" width="160px" height="40px" borderRadius="12px" color="white" mt="16px" onClick={()=>connectWallet()}>Connect Wallet</Button>
                }
                   
                {/* </Flex> */}
             

{/*               
              <Spacer /> */}

              {/* <Flex h="8"  mt={showText ? "10px" :0}>
               
                <SocialMedia  />
              </Flex> */}
            </>
          )}
        </Flex>
        <NetworkModal displayNetwork={displayNetwork} setDisplayNetwork={setDisplayNetwork} />
    </>
  );
};

export default Index;
